<template>
  <div class="inputs-wrapper">
    <basic-input
      v-model="name"
      type="text"
      label="Status name"
      :setFocus="true"
      @keyup.enter="saveChanges"
    />
  </div>
  <div class="inputs-wrapper">
    <basic-button label="Create status" @click="saveChanges" />
  </div>
</template>
<script setup lang="ts">
import { ModalStore } from "../../store/modalStore";
import api from "@/api";
import { openCustomToast } from "@/assets/js/helpers";
import { CompanyStore } from "@/store/companyStore";

const modalStore = ModalStore();
const companyStore = CompanyStore();
const name = ref<string | null>(null);
const props = defineProps(["options"]);
defineEmits(["close"]);

const oldName = ref<string | null>(null);

onMounted(() => {
  oldName.value = props.options.data.sta_name;
  name.value = props.options.data.sta_name;
});

async function saveChanges() {
  if (!name.value) {
    openCustomToast("Status name field is required", "error");
    return;
  }
  if (name.value === oldName.value) {
    openCustomToast("The field 'Status name' has not been changed", "error");
    return;
  }
  const params: any = {
    sta_name: name.value,
    cmp_id: companyStore.getActiveCompany?.cmp_id,
  };
  try {
    await api.editStatus(params, props.options.data.sta_id);
    openCustomToast("You have successfully changed your status", "success");
    if (props.options.update) {
      props.options.update();
    }
    modalStore.setModalData(null);
  } catch (error: any) {
    openCustomToast("An error occurred while changing the status", "error");
  }
}
</script>
<style lang="scss" scoped>
.inputs-wrapper {
  margin-bottom: 15px;
}
</style>
